module.exports = __webpack_public_path__ + "img/brand-left.dccf530b.png";